import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BankPaymentPage } from './bank-payment.page';

const routes: Routes = [
  {
    path: '',
    component: BankPaymentPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BankPaymentPageRoutingModule {}
